<template>
    <div>
    <label for="organizer">{{ label }}</label>
    <select v-model="selectedOption" name="organizer" class="select-style organizer" id="organizer">
      <option v-for="(option, key) in options" :key="option" :value="key">{{ option }}</option>
      <option disabled selected value> ------------------------</option>
      <option value="remove-grouping"> Remove Grouping </option>

    </select>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import store from '../store.js';

export default{
    watch: {
      selectedOption: function(val){
        if(this.useGroup === true){
          if(val == 'remove-grouping'){
            store.dispatch('setGrouping', null);
          }else{
            store.dispatch('setGrouping', val);
          }
        }
        else if(this.sort === true){
          //sort here
        }
      }
    },
    props: {
      useSort: { default: false },
      groupByOptions: {default: () => ({})},
      sortByOptions: {default: () => ({})},
      useGroup: {default:false}
    },
    data(){
      return {
        selectedOption: ''
      };
    },
    computed: {
      ...mapState({
        groupBy: state => state.groupBy,
        group: state => state.group
      }),
      label: function(){
        let label = '';
        if(this.useGroup === true){
          label = 'Group By';
        }else if (this.useSort === true){
          label = 'Sort By';
        }
        return label;
      },
      options: function(){
        let options = '';
        if(this.useGroup === true){
          options = this.groupByOptions;
        }else if(this.useSort === true){
          options = this.sortByOptions;
        }
        return options;
      }
    },
    methods: {

    },
    components: {

    }
};

</script>
<style lang="scss" scoped>
  label{
    color:grey;
  }
  .organizer{
  }
  select.select-style:focus {
    outline: none;
  }
  .select-style {

  border: 1px solid #ccc;
  border-radius: 3px;
  overflow: hidden;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding:6px;
  color:grey;
  width: 70%;
  background: white url('../assets/angle-arrow-down.svg') no-repeat 95% 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/Organizer.vue